import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Header } from "./shared";
import { FloppyDisk } from "@phosphor-icons/react";
import PlayerOfGameAdmin from "./PlayerOfGameAdmin";

const STAT_KEYS = ["points", "rebounds", "assists", "steals", "blocks"];

export default function PlayerOfGameTab() {
  const [weights, setWeights] = useState({});
  const [savingWeights, setSavingWeights] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setWeights(r.data?.mvp_weights || {})).catch(() => {});
  }, []);

  const saveWeights = async () => {
    setSavingWeights(true);
    try { await api.put("/settings", { mvp_weights: weights }); toast.success("MVP formula saved"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSavingWeights(false); }
  };

  return (
    <div data-testid="potg-tab">
      <Header title="Player of the Game" />

      <PlayerOfGameAdmin />

      {/* MVP Race formula weights (powers the public MVP Race leaderboard) */}
      <div className="border border-white/10 bg-[#121212] p-5 mt-12" data-testid="mvp-weights-editor">
        <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#FF5722] font-semibold">MVP Race Formula</p>
            <p className="text-white/40 text-xs mt-0.5">Weighted score = sum of each stat × its weight. Powers the public MVP Race leaderboard.</p>
          </div>
          <button onClick={saveWeights} disabled={savingWeights} data-testid="save-weights-btn" className="flex items-center gap-2 bg-[#FF5722] hover:bg-[#FF7043] disabled:opacity-50 text-black font-bold uppercase tracking-wide px-4 py-2 text-xs transition-colors"><FloppyDisk size={16} />{savingWeights ? "Saving…" : "Save Formula"}</button>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
          {STAT_KEYS.map((k) => (
            <div key={k}>
              <label className="block text-[10px] font-semibold uppercase tracking-wide text-white/50 mb-1">{k}</label>
              <input type="number" step="0.1" value={weights[k] ?? 0} onChange={(e) => setWeights((w) => ({ ...w, [k]: parseFloat(e.target.value) || 0 }))} data-testid={`weight-${k}`} className="w-full bg-[#1A1A1A] border border-white/15 px-3 py-2 text-sm tabular-nums focus:outline-none focus:ring-2 focus:ring-[#FF5722]" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
